import { PromoBanner } from '../PromoBanner';

type TElekkGiveawayUpsellProps = {
  className?: string;
};

export function ElekkGiveawayUpsell(props: TElekkGiveawayUpsellProps) {
  return (
    <PromoBanner
      className={props.className}
      url="https://rio.gg/elekkgiveaway_up"
      blurb={
        <>
          ⚡ <strong style={{ color: '#fbbf24' }}>RUN KEYS</strong> for your chance to win the exclusive{' '}
          <strong style={{ color: '#e879f9' }}>Thunder-Ridged Elekk Mount!</strong> Complete dungeons to earn entries
          into the raffle for 1 of 10 of these RARE in-game mounts. <em>Registration Required.</em>
        </>
      }
      buttonText="ENTER NOW"
      trackingSlug="elekk_giveaway_upsell"
      imagePath="/images/upsells/elekk-giveaway/ElekkWinMeUpsell.png"
      imageAlt="Run keys to win the Thunder-Ridged Elekk Mount"
      imageWidth={80}
      imageHeight={68}
      borderColor="#c026d3"
      background="linear-gradient(76deg, #1a0d2e 0%, #3d1a5e 50%, #1a0d2e 100%)"
      buttonColor="#fbbf24"
      buttonTextColor="#1a0d2e"
    />
  );
}
